import { gql } from "@apollo/client";

const CLIP_FIELDS = gql`
  fragment ClipFields on Clip {
    createdAt
    previewUrl
    score
    shareId
    thumbnailOverlayUrl: thumbnailUrl(style: OVERLAY)
    thumbnailStandardUrl: thumbnailUrl(style: STANDARD)
    title
    user {
      _id
      avatarUrl
      username
    }
    views
  }
`;

const CLIPS_RECOMMENDED = gql`
  ${CLIP_FIELDS}

  query clipsRecommended($limit: Int) {
    clipsRecommended(limit: $limit) {
      ...ClipFields
    }
  }
`;

const CLIPS_PROFILE = gql`
  ${CLIP_FIELDS}

  query ClipsProfile(
    $first: Int
    $after: String
    $filters: ClipFilter!
    $userId: String
  ) {
    getUser(_id: $userId) {
      clips(first: $first, after: $after, filters: $filters) {
        nodes {
          ...ClipFields
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
          totalCount
        }
      }
    }
  }
`;

export { CLIPS_RECOMMENDED, CLIPS_PROFILE };
